/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Achievement grouping for filter tabs on the hub page
 * @export
 */
export const AchievementCategory = {
    COMPETITION: 'COMPETITION',
    COMMUNITY: 'COMMUNITY',
    ENGAGEMENT: 'ENGAGEMENT',
    MILESTONE: 'MILESTONE'
} as const;
export type AchievementCategory = typeof AchievementCategory[keyof typeof AchievementCategory];


export function instanceOfAchievementCategory(value: any): boolean {
    for (const key in AchievementCategory) {
        if (Object.prototype.hasOwnProperty.call(AchievementCategory, key)) {
            if (AchievementCategory[key as keyof typeof AchievementCategory] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AchievementCategoryFromJSON(json: any): AchievementCategory {
    return AchievementCategoryFromJSONTyped(json, false);
}

export function AchievementCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): AchievementCategory {
    return json as AchievementCategory;
}

export function AchievementCategoryToJSON(value?: AchievementCategory | null): any {
    return value as any;
}

export function AchievementCategoryToJSONTyped(value: any, ignoreDiscriminator: boolean): AchievementCategory {
    return value as AchievementCategory;
}

